module.exports = __webpack_public_path__ + "fb67e9f23bbbc9372897a0dc6b4af2e7.fbx";